module.exports = __webpack_public_path__ + "img/GDQ-svarsstapel_60.ac0eaf6f.gif";